// @flow
import * as React from 'react';
import Radium from 'radium';

import { Card, CardHeader, CardBlock } from 'reactstrap';
import { Colors, Spacing } from 'utils/styleguide';

const COLORS = [
  Colors.Primary,
  Colors.Profile,
  Colors.Feedback,
  Colors.Comment,
  Colors.Green,
];

type Props = {
  title: string,
  votes: { [answer: string]: number },
  statusComponent?: React.Node,
};

class SurveyResult extends React.PureComponent<Props> {
  render() {
    const { title, votes, statusComponent, type } = this.props;
    const votesCount = Object.values(votes).reduce(
      (acc, curr) => acc + curr,
      0
    );

    return (
      <Card style={styles.root}>
        <CardHeader style={styles.title}>
          <span>
            {title} {!!statusComponent ? statusComponent : ''}
          </span>
          <span>
            {votesCount} Stimme{votesCount !== 1 ? 'n' : ''}
          </span>
        </CardHeader>
        <CardBlock>
          {Object.keys(votes).map((answer, index) => {
            const backgroundColor = COLORS[index % COLORS.length];
            const count = votes[answer];
            const width = votesCount > 0 ? count / votesCount : 0.01;
            return (
              <div key={answer} style={styles.answer}>
                <div>
                  <span>{answer}</span>{' '}
                  <span style={styles.votesCount}>
                    ({count} Stimme{count !== 1 ? 'n' : ''})
                  </span>
                </div>
                <div style={styles.bar}>
                  <div
                    style={[
                      styles.innerBar,
                      {
                        backgroundColor,
                        width: `${Math.max(1.0, width * 100).toFixed(0)}%`,
                      },
                    ]}
                  />
                </div>
              </div>
            );
          })}
        </CardBlock>
      </Card>
    );
  }
}

const styles = {
  root: {
    width: '100%',
  },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    fontWeight: 'bold',
  },
  answer: {
    marginBottom: Spacing.Nano,
  },
  bar: {
    height: 4,
    width: '100%',
  },
  innerBar: {
    height: 4,
  },
  votesCount: {
    color: Colors.LightGrey,
    marginLeft: Spacing.Nano,
  },
  description: {
    color: Colors.LightGrey,
  },
};

export default Radium(SurveyResult);



// WEBPACK FOOTER //
// ./src/components/SurveyResult/SurveyResult.js